/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Workout_Detail_SecondsInputs */

const en_us2_workout_detail_seconds = /** @type {(inputs: Workout_Detail_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const pt_br2_workout_detail_seconds = /** @type {(inputs: Workout_Detail_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const es_419_workout_detail_seconds = /** @type {(inputs: Workout_Detail_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const pt_pt2_workout_detail_seconds = /** @type {(inputs: Workout_Detail_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const fr_fr2_workout_detail_seconds = /** @type {(inputs: Workout_Detail_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const de_de2_workout_detail_seconds = /** @type {(inputs: Workout_Detail_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const it_it2_workout_detail_seconds = /** @type {(inputs: Workout_Detail_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

/**
* | output |
* | --- |
* | "{seconds} s" |
*
* @param {Workout_Detail_SecondsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_detail_seconds = /** @type {((inputs: Workout_Detail_SecondsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Detail_SecondsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_detail_seconds(inputs)
	if (locale === "es-419") return es_419_workout_detail_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_detail_seconds(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_detail_seconds(inputs)
	if (locale === "de-DE") return de_de2_workout_detail_seconds(inputs)
	if (locale === "it-IT") return it_it2_workout_detail_seconds(inputs)
	return en_us2_workout_detail_seconds(inputs)
});
export { workout_detail_seconds as "workout.detail_seconds" }